import { render, staticRenderFns } from "./editVersion.vue?vue&type=template&id=1e5441b4&scoped=true&"
import script from "./editVersion.vue?vue&type=script&lang=js&"
export * from "./editVersion.vue?vue&type=script&lang=js&"
import style0 from "./editVersion.vue?vue&type=style&index=0&id=1e5441b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5441b4",
  null
  
)

export default component.exports